export const objectKeys = <T>(object: object): T[] => Object.keys(object) as T[]
export const objectFromEntries = <T>(entries: [unknown, unknown][]): T => Object.fromEntries(entries) as T
